<template>
  <div>
    <my-title :img='img' title='董事长致辞'></my-title>
    <div class="speech center" v-html="content">
      
    </div>
  </div>
</template>

<script>
import myTitle from '../../components/IntoTheGroup/IntoTheGroup_title' 
import {selectArticleDetails} from '../../api/article/selectArticleDetails'  // 查文章详情
export default {
  data() {
    return {
      img: require('../../assets/img/icon_speech.png'),
      catId: 26,
      content: ''
    }
  },
  components: {
    myTitle
  },
  created() {
    this.getArticleDetails()
  },
  methods: {
    getArticleDetails() {
      selectArticleDetails({catId: this.catId}).then(res => {
        if(res.data.length === 0) return; 
        this.content = res.data[0].content
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/base.scss';
  .speech {
    padding: 0 0 50px;
    width: 1200px;
    > p {
    }
  }

  @media screen and(max-width: 1200px) {
    .speech {
      width: 1000px;
    }
  }

  @media screen and(max-width: 768px) {
    .speech {
      width: 90%;
    }
  }
  
</style>